import React, { useState } from "react";
import { Dialog, useMediaQuery, useTheme } from "@material-ui/core";
import classNames from "classnames";
import { MdWarning } from "react-icons/md";
import { connect } from "react-redux";

const ConfirmationModal = ({
  modalProps,
  mode,
  onCancel,
  onSubmit,
  title,
  description,
  user,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [acknowledged, setAcknowledged] = useState(false);

  return (
    <Dialog
      // classes={{ paper: { maxHeight: "100%" } }}
      fullScreen={fullScreen}
      {...modalProps}
    >
      <div className="text-center px-8 py-16">
        {/* Icon */}
        <div className="flex justify-center">
          <MdWarning
            className={classNames({
              "text-red-600": mode === "terminate",
              "text-yellow-400": mode === "update",
            })}
            size={128}
          />
        </div>
        {/* Content */}
        <div className="space-y-4 ">
          <h1 className="font-bold md:text-4xl text-2xl tracking-wide">
            {title}
          </h1>
          <h3 className="text-base font-medium">{description}</h3>
        </div>
        {/* Select */}
        <div className="mt-8 space-x-4">
          <input
            id="confirmuser"
            type="checkbox"
            name="confirmuser"
            checked={acknowledged}
            onChange={() => setAcknowledged((val) => !val)}
          />
          <label className="font-bold text-base" htmlFor="confirmuser">
            Acknowledge action as {user.name}
          </label>
        </div>
        {/* Buttons */}
        <div className="mt-12 space-y-4 flex flex-col items-center">
          <button
            onClick={onSubmit}
            disabled={!acknowledged}
            className={classNames({
              "uppercase text-center px-4 py-2 tracking-wide font-bold block rounded shadow outline-none border-2 ": true,
              "opacity-25": !acknowledged,
              "border-red-600 text-red-600": mode === "terminate",
              "border-black text-black": mode === "update",
            })}
          >
            {mode === "terminate" ? "Terminate" : "Update"}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="uppercase text-center px-4 py-2 tracking-wide font-bold block border-black border-2 rounded shadow outline-none"
          >
            Cancel
          </button>
        </div>
      </div>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(ConfirmationModal);
